import React from 'react';

export const ISpringHeader = props => (
  <div className="ispring-badge__container">
    {props.withBadge && <div className="ispring-badge__image">new</div>}
    Моё обучение
  </div>
);